<script>
export default {
  name: "IconHappy",
}
</script>

<template>
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24" fill="none"><path d="M12 2C6.486 2 2 6.486 2 12s4.486 10 10 10 10-4.486 10-10S17.514 2 12 2m0 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8"/><path d="M8.5 12a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M15.493 11.986a1.493 1.493 0 1 0 0-2.986 1.493 1.493 0 0 0 0 2.986M12 18c4 0 5-4 5-4H7s1 4 5 4"/></svg>
</template>
